<div class="table-responsive">
    <table class="table table-striped table-hover settings-service-request-list footable">
        <thead>
            <tr [ngClass]="{'noSort': settingsIncidentReportService.data.allIncidentReportsSettings.data.length < 2}">
                <th></th>
                <th (click)="orderBy('id', $event)">
                    ID # <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('name', $event)">
                    Rule Set Name <span class="footable-sort-indicator"></span>
                </th>
                <th>Buildings</th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc">
                    Created On <span class="footable-sort-indicator"></span>
                </th>
                <th>Created By</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of settingsIncidentReportService.data.allIncidentReportsSettings.data; index as index;"
                [ngClass]="{'footable-odd': (index % 2 === 0)}"
                (click)="toggleCheck(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [(ngModel)]="item.checked">
                        <label>
                            <svg-checked></svg-checked>
                        </label>
                    </label>
                </td>
                <td>
                    <div class="table-mobile-left">
                        <span>ID</span>
                    </div>
                    <span>{{item.id}}</span>
                </td>
                <td>
                    <div class="table-mobile-left">
                        <span>Rule Set Name</span>
                    </div>
                    <span>{{item.name}}</span>
                </td>
                <td class="table-hint-td">
                    <div class="table-mobile-left">
                        <span>Buildings</span>
                    </div>
                    <div class="clickable-text mtv-primary-color" (click)="showHint($event)">
                        <span *ngFor="let building of item.buildings; let last = last;">
                            {{building.name}}{{!last ? ', ' : ''}}
                        </span>
                    </div>
                    <div class="table-hint {{index > 7 ? 'up' : 'down'}}">
                        <span *ngFor="let building of item.buildings; let last = last;">
                            {{building.name}}{{!last ? ', ' : ''}}
                        </span>
                    </div>
                </td>
                <td>
                    <div class="table-mobile-left">
                        <span>Created On</span>
                    </div>
                    <span>{{item.createdAt | mccDate:false:true}}</span>
                </td>
                <td>
                    <div class="table-mobile-left">
                        <span>Created By</span>
                    </div>
                    <span>{{item.createdBy}}</span>
                </td>
            </tr>

            <tr *ngFor="let item of settingsIncidentReportService.emptyRowService.emptyRow" class="empty-row"
                style="cursor: default;">
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    <h2 *ngIf="settingsIncidentReportService.data.allIncidentReportsSettings.total == 0 && !settingsIncidentReportService.showServiceUnavailable"
        class="text-center">
        Result Not Found
    </h2>
    <h2 *ngIf="settingsIncidentReportService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-incident-report/settings-incident-report-list/settings-incident-report-list.component.html